import React, {
  useEffect,
  useState
} from 'react';

import {
  fetchAgents
} from '../../services/agentService';

function AgentManagement() {

  const [agents, setAgents] =
    useState([]);

  useEffect(() => {

    loadAgents();

  }, []);

  const loadAgents = async () => {

    try {

      const data =
        await fetchAgents();

      setAgents(data);

    } catch (error) {

    }
  };

  return (
    <div>

      <h2>
        نمایندگان
      </h2>

      {agents.map((agent) => (

        <div
          key={agent.id}
          className="agent-card"
        >

          <h3>
            {agent.name}
          </h3>

          <p>
            {agent.phone}
          </p>

        </div>

      ))}

    </div>
  );
}

export default AgentManagement;